import { render, staticRenderFns } from "./TouristPrivacyCard.vue?vue&type=template&id=71d4c566&scoped=true"
import script from "./TouristPrivacyCard.vue?vue&type=script&lang=js"
export * from "./TouristPrivacyCard.vue?vue&type=script&lang=js"
import style0 from "./TouristPrivacyCard.vue?vue&type=style&index=0&id=71d4c566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d4c566",
  null
  
)

export default component.exports